"use client"

import { useState, useEffect } from "react"
import { Plus, X, ArrowLeft } from "lucide-react"
import { Button } from "../../../components/ui/button"
import { CategoryList } from "./category-list"
import { CategoryModal } from "./category-modal"
import { KitsView } from "./kits-view"
import { deleteCategory, deleteKit, editCategory, editKit, registerCategory, registerKit } from "../../../API"

export type Category = {
    id: string
    name: string
}

export type Kit = {
    id: string
    categoryId: string
    name: string
    thumb: string
    price1: number
    price2: number
    price3: number
    description: string
    features: string[]
    path: string
}

interface CategoryModalProps {
    isOpen: boolean
    onClose: () => void
}

export function CategoryManager({ isOpen, onClose }: CategoryModalProps) {
    const [categories, setCategories] = useState<Category[]>([])
    const [kits, setKits] = useState<Kit[]>([])
    const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState<Category | null>(null)
    const [viewingCategory, setViewingCategory] = useState<Category | null>(null)

    useEffect(() => {
        //console.log("kits atualizados:", kits)
    }, [kits])

    const handleAddCategory = async (name: string) => {

        const id = await registerCategory({
            name,
        })

        const newCategory: Category = {
            id: id,
            name,
        }

        setCategories([...categories, newCategory])
    }

    (window as { [key: string]: any }).handleAddCategory = async (name: string, id: string) => {

        const newCategory: Category = {
            id,
            name,
        }

        setCategories((prev) => [...prev, newCategory]) // ✅ agora sempre acumula corretamente
    }

    const handleEditCategory = (id: string, name: string) => {
        setCategories(categories.map((cat) => (cat.id === id ? { ...cat, name } : cat)))

        editCategory(id, name);
    }

    const handleDeleteCategory = (id: string) => {

        if (window.confirm("Deletar essa categoria? Ação não pode ser desfeita!")) {
            setCategories(categories.filter((cat) => cat.id !== id))
            setKits(kits.filter((kit) => kit.categoryId !== id))

            deleteCategory(id)
        }
    }

    const handleCategoryClick = (category: Category) => {
        setViewingCategory(category)
    }

    const handleAddKit = (kit: Omit<Kit, "id">) => {
        const newKit: Kit = {
            ...kit,
            id: Date.now().toString(),
        }
        setKits([...kits, newKit])

        registerKit(newKit);
    }

    (window as { [key: string]: any }).handleAddKit = async (id: any, categoryId: any, name: any, thumb: any, price1: any, price2: any, price3: any, description: any, features: any, path: any) => {

        const newKit: Kit = {
            id,
            categoryId,
            name,
            thumb,
            price1,
            price2,
            price3,
            description,
            features,
            path
        }

        setKits((prev) => [...prev, newKit]) // ✅ agora sempre acumula corretamente
    }

    const handleEditKit = (id: string, updatedKit: Omit<Kit, "id">) => {
        setKits(kits.map((kit) => (kit.id === id ? { ...updatedKit, id } : kit)))
        editKit(updatedKit, id)
    }

    const handleDeleteKit = (id: string) => {

        if (window.confirm("Deletar esse Kit? Ação não pode ser desfeita!?")) {
            setKits(kits.filter((kit) => kit.id !== id))
            deleteKit(id)
        }

    }

    if (viewingCategory) {
        return (
            <KitsView
                category={viewingCategory}
                kits={kits.filter((kit) => kit.categoryId === viewingCategory.id)}
                onBack={() => setViewingCategory(null)}
                onAddKit={handleAddKit}
                onEditKit={handleEditKit}
                onDeleteKit={handleDeleteKit}
            />
        )
    }

    if (!isOpen) return null

    return (
        <main className="min-h-screen bg-background h-screen overflow-y-scroll">
            {/**<Button variant="ghost" size="sm" onClick={onClose} className="text-black hover:bg-white/20 rounded-full p-2 absolute top-[10px] right-[10px]">
                <X className="w-6 h-6" />
            </Button> */}


            <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">

                <Button variant="ghost" onClick={onClose} className="mb-4 gap-2 text-primary hover:text-foreground">
                    <ArrowLeft className="h-4 w-4" />
                    Voltar para Modelos
                </Button>

                <div className="mb-8 flex items-center justify-between">
                    <div>
                        <h1 className="font-sans text-4xl font-bold tracking-tight text-foreground">Categorias Esportivas</h1>
                        <p className="mt-2 text-muted-foreground">Gerencie suas categorias e kits esportivos</p>
                    </div>
                    <Button
                        onClick={() => {
                            setSelectedCategory(null)
                            setIsCategoryModalOpen(true)
                        }}
                        size="lg"
                        className="gap-2 bg-primary text-primary-foreground hover:bg-primary/90"
                    >
                        <Plus className="h-5 w-5" />
                        Nova Categoria
                    </Button>
                </div>

                <CategoryList
                    categories={categories}
                    onEdit={(category) => {
                        setSelectedCategory(category)
                        setIsCategoryModalOpen(true)
                    }}
                    onDelete={handleDeleteCategory}
                    onClick={handleCategoryClick}
                />

                <CategoryModal
                    isOpen={isCategoryModalOpen}
                    onClose={() => {
                        setIsCategoryModalOpen(false)
                        setSelectedCategory(null)
                    }}
                    onSave={(name) => {
                        if (selectedCategory) {
                            handleEditCategory(selectedCategory.id, name)
                        } else {
                            handleAddCategory(name)
                        }
                        setIsCategoryModalOpen(false)
                        setSelectedCategory(null)
                    }}
                    initialValue={selectedCategory?.name}
                />
            </div>
        </main>
    )
}